module.exports = __webpack_public_path__ + "static/technology-a7c784a8275a1a8a2f1800da2ca2b956.jpg";